// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-components-table-styles-module__table--cvoSZ {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  font-weight: 300;
  line-height: 1.75;
  height: 100%;
  border-style: none;
  margin: 0;
  table-layout: auto;
  color: #000;
}

.src-js-components-table-styles-module__table--cvoSZ td,
.src-js-components-table-styles-module__table--cvoSZ tr,
.src-js-components-table-styles-module__table--cvoSZ th {
  padding: 12px;
  line-height: 1.42857143;
  border-style: none;
  text-align: center;
}

.src-js-components-table-styles-module__cellValignTop--UTlpl {
  vertical-align: top;
}
.src-js-components-table-styles-module__cellValignMiddle--RbCBv {
  vertical-align: middle;
}

.src-js-components-table-styles-module__table--cvoSZ th {
  font-weight: bold;
}

.src-js-components-table-styles-module__table--cvoSZ > thead > tr > th {
  vertical-align: bottom;
  border-style: none;
}

.src-js-components-table-styles-module__tableStriped--q0l5d > tbody > tr:nth-of-type(even) {
  background-color: #d3d7da;
}

tr.src-js-components-table-styles-module__clickable--XEUK4:nth-of-type(even):hover {
  background-color: #8a97a4;
}

.src-js-components-table-styles-module__tableStriped--q0l5d > tbody > tr:nth-of-type(odd) {
  background-color: #eaeaea;
}

tr.src-js-components-table-styles-module__clickable--XEUK4:nth-of-type(odd):hover {
  background-color: #c1c7cd;
}

tr.src-js-components-table-styles-module__clickable--XEUK4:hover {
  cursor: pointer;
}

.src-js-components-table-styles-module__tableHead--j3u3F {
  background-color: #445566;
  color: #ffffff;
  border-style: none;
}

.src-js-components-table-styles-module__tableHead--j3u3F th:first-child {
  border-top-left-radius: 10px;
}

.src-js-components-table-styles-module__tableHead--j3u3F th:last-child {
  border-top-right-radius: 10px;
}

.src-js-components-table-styles-module__header--f2m60 {
  font-weight: normal !important;
  border-bottom: none !important;
}

.src-js-components-table-styles-module__tbody--eT8_m {
  border-color: inherit;
}

td.src-js-components-table-styles-module__noRowsValue--mhnSX {
  color: #000000;
  font-weight: 400;
  text-align: center;
  padding: 15px 0 50px 0;
}

td.src-js-components-table-styles-module__loading--SZzZ4 {
  font-weight: 400;
  text-align: center;
  padding: 25px 0 40px 0;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/table/styles.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA;;;EAGE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB","sourcesContent":[".table {\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 20px;\n  font-weight: 300;\n  line-height: 1.75;\n  height: 100%;\n  border-style: none;\n  margin: 0;\n  table-layout: auto;\n  color: #000;\n}\n\n.table td,\n.table tr,\n.table th {\n  padding: 12px;\n  line-height: 1.42857143;\n  border-style: none;\n  text-align: center;\n}\n\n.cellValignTop {\n  vertical-align: top;\n}\n.cellValignMiddle {\n  vertical-align: middle;\n}\n\n.table th {\n  font-weight: bold;\n}\n\n.table > thead > tr > th {\n  vertical-align: bottom;\n  border-style: none;\n}\n\n.tableStriped > tbody > tr:nth-of-type(even) {\n  background-color: #d3d7da;\n}\n\ntr.clickable:nth-of-type(even):hover {\n  background-color: #8a97a4;\n}\n\n.tableStriped > tbody > tr:nth-of-type(odd) {\n  background-color: #eaeaea;\n}\n\ntr.clickable:nth-of-type(odd):hover {\n  background-color: #c1c7cd;\n}\n\ntr.clickable:hover {\n  cursor: pointer;\n}\n\n.tableHead {\n  background-color: #445566;\n  color: #ffffff;\n  border-style: none;\n}\n\n.tableHead th:first-child {\n  border-top-left-radius: 10px;\n}\n\n.tableHead th:last-child {\n  border-top-right-radius: 10px;\n}\n\n.header {\n  font-weight: normal !important;\n  border-bottom: none !important;\n}\n\n.tbody {\n  border-color: inherit;\n}\n\ntd.noRowsValue {\n  color: #000000;\n  font-weight: 400;\n  text-align: center;\n  padding: 15px 0 50px 0;\n}\n\ntd.loading {\n  font-weight: 400;\n  text-align: center;\n  padding: 25px 0 40px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `src-js-components-table-styles-module__table--cvoSZ`,
	"cellValignTop": `src-js-components-table-styles-module__cellValignTop--UTlpl`,
	"cellValignMiddle": `src-js-components-table-styles-module__cellValignMiddle--RbCBv`,
	"tableStriped": `src-js-components-table-styles-module__tableStriped--q0l5d`,
	"clickable": `src-js-components-table-styles-module__clickable--XEUK4`,
	"tableHead": `src-js-components-table-styles-module__tableHead--j3u3F`,
	"header": `src-js-components-table-styles-module__header--f2m60`,
	"tbody": `src-js-components-table-styles-module__tbody--eT8_m`,
	"noRowsValue": `src-js-components-table-styles-module__noRowsValue--mhnSX`,
	"loading": `src-js-components-table-styles-module__loading--SZzZ4`
};
export default ___CSS_LOADER_EXPORT___;
